var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "cart-icon-container",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.visitCart.apply(null, arguments)
        }
      }
    },
    [
      _vm.cartProductsCount && _vm.cartProductsCount > 0
        ? _c("span", { staticClass: "count" }, [
            _vm._v("\n        " + _vm._s(_vm.cartProductsCount) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "cart-icon",
          attrs: {
            viewBox: "0 0 20 27",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Style-Guide",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Header---Style-Guide",
                    transform: "translate(-125.000000, -425.000000)",
                    fill: "#000000",
                    "fill-rule": "nonzero"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M144.333333,431.974425 L140.166667,431.974425 L140.166667,430.558824 C140.166667,427.485934 137.833333,425 135,425 C132.166667,425 129.833333,427.485934 129.833333,430.558824 L129.833333,431.974425 L125.666667,431.974425 C125.3,431.974425 125,432.285166 125,432.664962 L125,449.928389 C125,451.067775 125.9,452 127,452 L143,452 C144.1,452 145,451.067775 145,449.928389 L145,432.664962 C145,432.285166 144.7,431.974425 144.333333,431.974425 Z M131.5,430.558824 C131.5,428.452685 133.066667,426.726343 135,426.726343 C136.933333,426.726343 138.5,428.452685 138.5,430.558824 L138.5,431.974425 L131.5,431.974425 L131.5,430.558824 Z",
                      id: "Shape"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2aeb7d8", { render: render, staticRenderFns: staticRenderFns })
  }
}